import { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";

const PrivateKey = () => {
    const [modal, setModal] = useState(false);
    const [stepFirst, setStepFirst] = useState(true);

    const handleModal = () => {
        setModal(!modal);
    }
    return ( 
        <>
            <Card className="card-dark mb-3">
                <Card.Body className="p-4">
                    <Row className="align-items-center">
                        <Col sm={8} className="mb-sm-0 mb-3">
                            <h4>Private keys</h4>
                            <p>Create private keys to keep your funds and smart contracts secure.</p>
                        </Col>
                        <Col sm={4} className="text-center text-sm-end">
                        {localStorage.getItem('Login') === true || localStorage.getItem('Login') || localStorage.getItem('Login') ==="true" ?(<>
                            <Button onClick={handleModal}>Configure</Button>
                           
                        </>):(<>
                        
                            <Button  disabled onClick={handleModal}>Configure</Button>
                        </>)}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <div className={`modal-outer ${modal ? 'active' : ''}`}>
                <div class="modal-overlay"></div>
                <div className="modal_content">
                    <button className="btn_close" onClick={handleModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>

                    <div className="modal-section">
                        <div className="mb-5">
                            <div className="mb-4">
                                <h3 className="mb-4">Create a private key</h3>

                                <p>Create a private key to keep your funds and smart contracts secure. <a href="/">Learn more</a></p>
                        
                            </div>
                            <Row>
                                <Col sm={6} className="mb-3">
                                    <label className="label-card">
                                        <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                        <span className="d-flex justify-content-center align-items-center">
                                            <span className="label-card-name">Accessible EC DSA P256</span>
                                        </span>
                                    </label>
                                </Col>
                                <Col sm={6} className="mb-3">
                                    <label className="label-card">
                                        <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                        <span className="d-flex justify-content-center align-items-center">
                                            <span className="label-card-name">HSM EC DSA P256</span>
                                        </span>
                                    </label>
                                </Col>
                            </Row>
                        </div>

                        <div className="d-flex align-items-center justify-content-end">
                            <Button onClick={handleModal} variant="outline-primary me-3">Close</Button>
                            <Button disabled={stepFirst}>Configure else</Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
     );
}
 
export default PrivateKey;